import { useState } from "react";
import { AlertTriangle, CheckCircle2, Link2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { PlatformBadge } from "@/components/Badges";
import { api, errMsg, money } from "@/lib/api";

export const SuggestionCard = ({ s, onDone, compact = false }) => {
  const [envoi, setEnvoi] = useState(false);
  const associer = async () => {
    setEnvoi(true);
    try {
      await api.post("/associations", { bank_tx_id: s.depot.id, reservation_ids: s.reservations.map((r) => r.id) });
      toast.success(`${s.reservations.length} réservation(s) associée(s) au dépôt du ${s.depot.date}`);
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setEnvoi(false);
    }
  };
  return (
    <div className={`rounded-md border border-sky-200 bg-sky-50/60 ${compact ? "px-3 py-2" : "p-3"}`} data-testid={`suggestion-${s.depot.id}`}>
      <div className="flex flex-wrap items-start gap-3">
        <div className="min-w-0 flex-1 basis-full sm:basis-0">
          <p className="truncate text-sm font-medium text-slate-800" title={s.depot.description}>
            Dépôt du {s.depot.date} · <span className="tabular text-emerald-700">{money(s.depot.credit)}</span>
          </p>
          <p className="truncate text-xs text-slate-500">{s.depot.description}</p>
          <div className="mt-1 flex flex-wrap gap-x-3 gap-y-0.5 text-xs text-slate-700">
            {s.reservations.map((r) => (
              <span key={r.id}><span className="font-mono">{r.code}</span> · {r.date}{r.logement ? ` · ${r.logement}` : ""} · <span className="tabular">{money(r.total_verse)}</span></span>
            ))}
          </div>
        </div>
        <div className="text-left sm:text-right">
          {!compact && <PlatformBadge plateforme={s.depot.plateforme} />}
          <p className="tabular text-xs text-slate-600">Total {money(s.total)}</p>
          <p className={`tabular text-xs font-medium ${Math.abs(s.ecart) <= 2 ? "text-emerald-700" : "text-amber-700"}`} data-testid={`suggestion-ecart-${s.depot.id}`}>Écart {money(s.ecart)}</p>
        </div>
        <Button size="sm" disabled={envoi} onClick={associer} className="ml-auto h-8 self-center bg-emerald-700 hover:bg-emerald-800 sm:ml-0" data-testid={`suggestion-associer-${s.depot.id}`}>
          {envoi ? <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" /> : <Link2 className="mr-1.5 h-3.5 w-3.5" />}Associer
        </Button>
      </div>
      {s.frais_booking && (
        <p className={`mt-2 flex items-start gap-1.5 border-t border-sky-100 pt-1.5 text-xs ${s.frais_booking.explique ? "text-emerald-800" : "text-amber-800"}`} data-testid={`suggestion-frais-${s.depot.id}`}>
          {s.frais_booking.explique ? <CheckCircle2 className="mt-px h-3.5 w-3.5 shrink-0" /> : <AlertTriangle className="mt-px h-3.5 w-3.5 shrink-0" />}{s.frais_booking.texte}
        </p>
      )}
    </div>
  );
};
